import { FC, PropsWithChildren, useEffect } from "react";

import { AmplitudeFlagKey } from "@simplyk/common";

import { isTest } from "../constants/env";
import { AmplitudeExperienceContext } from "../contexts/AmplitudeExperienceContext";
import { useCurrentUserContext } from "../contexts/CurrentUserContext";
import { trpc } from "../helpers/trpc";

import { useAmplitudeFeatureFlag } from "@/hooks/amplitude/useAmplitudeFeatureFlag";

export const AmplitudeExperienceProvider: FC<PropsWithChildren> = ({ children }) => {
  const { organization } = useCurrentUserContext();
  const { mutateAsync: setNewPermissionExperienceValue } = trpc.setNewPermissionExperienceValue.useMutation();

  const isClosedWon = Boolean(organization?.fourthPaymentDate && organization?.stripeCustomAccountActiveAtUtc);

  const {
    isActive,
    loading: isNewPermissionExperienceActiveLoading,
    value: newPermissionExperienceValue,
  } = useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.NewPermissionExperience,
    userProperties: { organizationId: organization?.id || "" },
    organizationId: organization?.id,
    skip: Boolean(!organization?.id || !isClosedWon || isTest),
  });
  const isNewPermissionExperienceActive = Boolean(isTest || isActive);

  useEffect(() => {
    if (!isNewPermissionExperienceActiveLoading && newPermissionExperienceValue) {
      setNewPermissionExperienceValue({ value: newPermissionExperienceValue });
    }
  }, [isNewPermissionExperienceActiveLoading, setNewPermissionExperienceValue, newPermissionExperienceValue]);

  return (
    <AmplitudeExperienceContext.Provider
      value={{
        isNewPermissionExperience: {
          isActive: isNewPermissionExperienceActive,
          isLoading: isNewPermissionExperienceActiveLoading,
          value: newPermissionExperienceValue,
        },
      }}
    >
      {children}
    </AmplitudeExperienceContext.Provider>
  );
};
